var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavExtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0002 2.5H4.2002C3.08009 2.5 2.51962 2.5 2.0918 2.71799C1.71547 2.90973 1.40973 3.21547 1.21799 3.5918C1 4.01962 1 4.58009 1 5.7002V13.3002C1 14.4203 1 14.9801 1.21799 15.4079C1.40973 15.7842 1.71547 16.0905 2.0918 16.2822C2.5192 16.5 3.07899 16.5 4.19691 16.5H11.8031C12.921 16.5 13.48 16.5 13.9074 16.2822C14.2837 16.0905 14.5905 15.7839 14.7822 15.4076C15 14.9802 15 14.421 15 13.3031V11.5M16 6.5V1.5M16 1.5H11M16 1.5L9 8.5",
    stroke: "#1A1C21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavExtIcon);
export default __webpack_public_path__ + "static/media/navExtIcon.c280ddfe7ec45a8ca5b4b197aba8a8f9.svg";
export { ForwardRef as ReactComponent };